// Interfaces
import { ILayoutBackOfficeProps } from './interfaces'

// Components
import { BaseHeader, BackOfficeBaseCard } from 'components'
import { BackOfficeSidebar } from './components'

// Styles
import styles from './index.module.scss'

const LayoutBackOffice = ({ children, meta }: ILayoutBackOfficeProps) => {
  /**
   * @description Render icon
   *
   * @param {string} moduleName
   * @param {string} icon
   *
   * @return {string} string
   */
  const renderIcon = (moduleName: string, icon: string) => {
    const renderedIcon = moduleName === meta.module ? `${icon}-active` : icon

    return renderedIcon
  }

  return (
    <>
      {/* Header */}
      <BaseHeader />

      {/* Container */}
      <div className={styles.container}>
        {/* Sidebar */}
        <BackOfficeSidebar meta={meta} renderIcon={renderIcon} />

        {/* Your content goes here */}
        <div className={styles.body}>
          {meta?.attrs?.noBackOfficeCard ? (
            <div className="px-2">{children}</div>
          ) : meta?.attrs?.customBackOfficeCard ? (
            <meta.attrs.customBackOfficeCard meta={meta}>{children}</meta.attrs.customBackOfficeCard>
          ) : (
            <BackOfficeBaseCard meta={meta}>{children}</BackOfficeBaseCard>
          )}
        </div>
      </div>
    </>
  )
}

export { LayoutBackOffice }
